/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable import/no-cycle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useRef, useState, useEffect } from 'react';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Selection,
  Inject,
  Edit,
  Toolbar,
  Resize,
  Sort,
  Search,
  ForeignKey,
  Group,
  LazyLoadGroup,
  PdfExport,
  ExcelExport,
} from '@syncfusion/ej2-react-grids';
//  Filter,
import { Link, useNavigate } from 'react-router-dom';
import { ToolbarComponent, ItemsDirective, ItemDirective, AccordionComponent } from '@syncfusion/ej2-react-navigations';
import { DialogComponent, DialogUtility } from '@syncfusion/ej2-react-popups';
import { DropDownListComponent, MultiSelectComponent, CheckBoxSelection } from '@syncfusion/ej2-react-dropdowns';
import { TextBoxComponent, UploaderComponent } from '@syncfusion/ej2-react-inputs';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { Query } from '@syncfusion/ej2-data';
import { useStateContext } from '../contexts/ContextProvider';
import { Header } from '../components';
import profile from '../data/profile.png';
import scribeHow from '../data/scribehow.png';

import './Zackat.css';

const ManagerControlCenter = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  const { managerCount, isMobile, zRenderMode, reloadCounts, setReloadCounts } = useStateContext();
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=managercontrolcenter');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  let dialogInstance;
  const [selAnAssociate, setAnAssociate] = useState('');
  const [associateContent, setAssociateContent] = useState('');
  const [enableInvite, setInvite] = useState(true);
  const associateDatasource = [];
  let assocRef;
  const [hideDialog, setDialog] = useState(true);
  const [enableEditing, setEnableEditing] = useState(false);
  const [selRefresh, setRefresh] = useState('');

  const orgData = [];
  const [managersearch, setManagerSearch] = useState('');
  const [initialValues, setInitialValues] = useState([]);

  const multilineAttributes = {
    rows: 4, // Sets the initial visible number of lines to 4
  };

  const invite = { text: 'Invite', tooltipText: 'MobileApp Invitation', prefixIcon: 'e-resize', id: 'invite', disabled: false }; // enableInvite
  const add = { text: 'Add', tooltipText: 'Add Inventory', prefixIcon: 'e-add', id: 'add', disabled: false };
  const edit = { text: 'Edit', tooltipText: 'Edit Inventory', prefixIcon: 'e-edit', id: 'edit', disabled: false }; //! enableEditing
  const del = { text: 'Delete', tooltipText: 'Delete Inventory', prefixIcon: 'e-delete-2', id: 'delete', disabled: false };
  const excel = { text: 'Excel Export', tooltipText: 'Export', prefixIcon: 'e-export-excel', id: 'excel', disabled: false };
  const toolbarOptions = [add, edit, del, invite, excel];
  // 'PdfExport',
  const [currentCount, setCurrentCount] = useState(50);
  const [page, setPage] = useState(1);

  const { REACT_APP_API_ENDPOINT } = process.env;
  const valuerules = { required: true };
  const valuerulesnot = { required: false };
  const valueruleemail = { required: false, email: true };
  const fields = { value: '_id', text: 'name' };
  const grid = useRef(null);
  const dialogRef = useRef(null);
  const [selectedManagerOrg, setManagerOrganization] = useState('');
  const [selectedManagerRow, setManagerRow] = useState(0);
  const dataBound = (args) => {
    if (grid && grid.current) {
      grid.current.toolbarModule.toolbar.overflowMode = 'MultiRow';
    }
  };
  const [reload, setReload] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [groups, setGroups] = useState([]);
  const [sortOptions, setSortColumns] = useState({});
  const [selUploadOrganization, setUploadOrganization] = useState('');
  const [managerid, setManagerId] = useState('');
  const [smsOptin, setSMSOptin] = useState(false);
  const [emailOptin, setEmailOptin] = useState('');
  const [dataChanged, setDataChanged] = useState(false);
  const [crudUpdate, setCrudUpdate] = useState(false);
  const [crudCreate, setCrudCreate] = useState(false);
  const [crudDelete, setCrudDelete] = useState(false);
  const [crudImport, setCrudImport] = useState(false);
  useEffect(() => {
    if (data.role && data.role.associates && data.role.associates.permissions.includes('Create')) {
      setCrudCreate(true);
    }
    if (data.role && data.role.associates && data.role.associates.permissions.includes('Import')) {
      setCrudImport(true);
    }
    if (data.role && data.role.associates && data.role.associates.permissions.includes('Update')) {
      setCrudUpdate(true);
    }
    if (data.role && data.role.associates && data.role.associates.permissions.includes('Delete')) {
      setCrudDelete(true);
    }
  }, [data]);
  const dialogButtons = [{
    click: () => {
      dialogRef.current.hide();
    },
    buttonModel: { content: 'OK', isPrimary: true },
  }];

  const [selFirstName, setFirstName] = useState('');
  const [selLastName, setLastName] = useState('');
  const [selAssociates, setAssociates] = useState('');
  const [selAllAssociates, setAllAssociates] = useState([]);

  const [selOrganization, setOrganization] = useState('');
  const [selEmployeeImage, setEmployeeImage] = useState('');
  const [selMobile, setMobile] = useState('');
  const [selEmail, setEmail] = useState('');
  const [manager, setManager] = useState(null);
  const [selAddress, setAddress] = useState('');
  const [selAddress1, setAddress1] = useState('');
  const [selCity, setCity] = useState('');
  const [selState, setState] = useState('');
  const [selZip, setZip] = useState('');

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    usr.limit = 1;
    // fetch data
    const managerFetch = async () => {
      if (managerid !== '' && managerid !== 'add_manager') {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        const url = `${REACT_APP_API_ENDPOINT}/managers?${query}&managerid=${managerid}&abbrev=true`;
        if (!usr.loggedIn) {
          navigate('/login');
          return;
        }
        const mydata = await (
          await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        ).json();
        let associates = '';
        if (mydata) {
          setFirstName(`${mydata.managers[0].first ? mydata.managers[0].first : ''}`);
          setLastName(`${mydata.managers[0].last ? mydata.managers[0].last : ''}`);
          setMobile(`${mydata.managers[0].mobile ? mydata.managers[0].mobile : ''}`);
          setEmail(`${mydata.managers[0].email ? mydata.managers[0].email : ''}`);
          setAddress(mydata.managers[0].address ? mydata.managers[0].address : '');
          setAddress1(mydata.managers[0].address1 ? mydata.managers[0].address1 : '');
          setCity(mydata.managers[0].city ? mydata.managers[0].city : '');
          setState(mydata.managers[0].state ? mydata.managers[0].state : '');
          setZip(mydata.managers[0].zip ? mydata.managers[0].zip : '');
          setOrganization(mydata.managers[0].organizationid ? mydata.managers[0].organizationid : null);
          if (mydata.managers[0].image && mydata.managers[0].image.includes(mydata.managers[0]._id)) {
            const tm = new Date().getTime();
            setEmployeeImage(`${mydata.managers[0].image}&key=${tm}`);
          } else {
            setEmployeeImage('https://monaco.zackat.com/blank.png');
          }
          /*
          if (mydata.managers[0].associatenames) {
            // eslint-disable-next-line no-return-assign
            mydata.managers[0].associatenames.map((item) => (
              associates += `${item}, \r\n`
            ));
          }
          */
          if (mydata.managers[0].managedAssociates) {
            associates = '';
            // eslint-disable-next-line no-return-assign
            mydata.managers[0].managedAssociates.map((item) => (
              associates += `${item.associateName}, \r\n`
            ));
            setInitialValues(mydata.managers[0].managedAssociates.map((item) => item.associateId));
          }
        }

        setAssociates(associates);
        setManager(mydata.managers[0]);
      }
    };

    managerFetch();
  }, [managerid, reload]);

  const groupOptions = {
    enableLazyLoading: false,
    columns: groups,
  };
  useEffect(() => {
    // limit associates to the overall selection
    /*
    if (data && data.managers && data.managers.length > selectedManagerRow) {
      usr.organizationid = data.managers[selectedManagerRow - 1].organizationid;
    */
    if (selectedManagerOrg !== '') {
      usr.organizationid = selectedManagerOrg;
    } else {
      return;
    }
    // fetch data
    const associateFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/associates?${query}`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          // Orig set state when the data received
          if (!mydata.associates) {
            setAllAssociates([]);
          } else {
            const myassociates = [];
            mydata.associates.map((item) => (
              myassociates.push({ associateId: item._id, associateName: item.name })
            ));
            setAllAssociates(myassociates);
          }
        })
        .catch(() => {
        });
    };
    associateFetch();
  }, [selectedManagerOrg]);

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      usr.limit = 50;
      let p = 0;
      if (page > 1) {
        p = page - 1;
      }
      const skip = p * 50;
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      let url = `${REACT_APP_API_ENDPOINT}/managers?${query}&skip=${skip}&limit=50`;
      if (managersearch && managersearch.length > 0) {
        url = `${REACT_APP_API_ENDPOINT}/managers?${query}&skip=${skip}&search=${managersearch}`;
      }
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();
      if (mydata.user && mydata.user.preferences && mydata.user.preferences.managers) {
        if (mydata.user.preferences.managers.group) {
          setGroups(mydata.user.preferences.managers.group);
        } else {
          setGroups(['organizationid']);
        }
        if (mydata.user.preferences.managers.sort && mydata.user.preferences.managers.sort[0].direction) {
          const mysortedColumns = { columns: mydata.user.preferences.managers.sort };
          setSortColumns(mysortedColumns);
        }
      } else {
        setGroups(['organizationid']);
      }
      if (mydata && mydata.managers) {
        setCurrentCount(mydata.managers.length);
      }

      // set state when the data received
      setData(mydata);
      setLoading(false);
    };
    dataFetch();
  }, [reload, managersearch]);
  function dialogOK(f, element) {
    dialogInstance.hide();
  }

  function dialogClick(f, hdr, content, element) {
    let ok = null;
    if (f !== 'na') {
      ok = { text: 'OK', click: () => { dialogOK(f, element); } };
      if (grid && grid.current) {
        const selectedRow = grid.current.getSelectedRecords()[0];
        if (!selectedRow) {
          dialogClick('na', 'Manager Row', 'No manager selected', null);
          return;
        }
      }
    }
    dialogInstance = DialogUtility.confirm({
      title: hdr,
      content,
      okButton: ok,
      cancelButton: { text: 'Cancel',
        click: () => {
          dialogInstance.hide(); if (f === 'manage') {
            setInitialValues(element.value);
          }
        } },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  }
  const pageComponent = () => (
    <div style={{ float: 'left', width: '200px' }}>
      <div className="col-xs-12 col-sm-12 col-lg-6 col-md-6">
        <label htmlFor="showLimit" style={{ padding: '10px 40px 10px 0' }}>
          {selectedManagerRow}-{currentCount} / {currentCount < 50 ? currentCount : managerCount}
        </label>
        <ButtonComponent cssClass="e-small" iconCss="e-icons e-first-page" onClick={() => { setPage(1); setManagerRow(1); }} />
        <ButtonComponent cssClass="e-small" iconCss="e-icons e-chevron-left" onClick={() => { let p = page; if (p !== 1) { setPage(p -= 1); setManagerRow(1); } }} />
        &nbsp;&nbsp;Page {page} of {currentCount < 50 && page === 1 ? Math.ceil(currentCount / 50) : Math.ceil(managerCount / 50)}&nbsp;&nbsp;
        <ButtonComponent cssClass="e-small" iconCss="e-icons e-chevron-right" onClick={() => { let p = page; let cnt = managerCount; if (currentCount < 50) { cnt = currentCount; } if (p !== Math.ceil(cnt / 50) && p !== Math.ceil(managerCount / 50)) { setPage(p += 1); setManagerRow(1); } }} />
        <ButtonComponent cssClass="e-small" iconCss="e-icons e-last-page" onClick={() => { setPage(Math.ceil(managerCount / 50)); setManagerRow(1); }} />
      </div>
    </div>
  );
  const searchThis = () => {
    if (grid && grid.current) {
      const search = document.getElementById('managersearch');
      if (search) {
        if (search.value.includes('.')) {
          dialogClick('na', 'Manager Search Query', 'Please do not use the reserved period (.) character!', null);
          return;
        }

        setManagerSearch(search.value);
      } else {
        setManagerSearch('');
      }
    }
    setManagerRow(1);
  };

  const searchComponent = () => (
    <div className="pt-2 relative mx-auto text-gray-600">
      <TextBoxComponent
        placeholder="Search query"
        value={managersearch}
        width="300px"
        required
        id="managersearch"
        showClearButton
        cssClass="e-outline"
        floatLabelType="Never"
        onChange={(v) => { if (v.value.length === 0) { setManagerSearch(''); } }}
      />
      <button type="button" className="absolute right-0 top-0 mt-5 mr-8" onClick={searchThis}>
        <svg
          className="text-gray-600 h-4 w-4 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          id="Capa_1"
          x="0px"
          y="0px"
          viewBox="0 0 56.966 56.966"
          xmlSpace="preserve"
          width="512px"
          height="512px"
        >
          <path
            d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z"
          />
        </svg>
      </button>
    </div>
  );

  function handleChange(e) {
    let upData = null;
    for (let idx = 0; idx < data.managers.length; idx += 1) {
      if (data.managers[idx]._id === e.target.id) {
        upData = data.managers[idx];
        break;
      }
    }
    const filedata = new FormData();
    const imagedata = e.target.files[0];
    filedata.append('userfile', imagedata);
    if (upData !== null) {
      filedata.append('_id', upData._id);
      filedata.append('fileName', e.target.files[0].name);
    } else {
      return;
    }
    fetch(`${REACT_APP_API_ENDPOINT}/mfileup`, {
      method: 'POST',
      headers: {
        Authorization: `JWTToken ${usr.token}`,
      },
      body: filedata,
    })
      .then((response) => response.json())
      .then((responseJson) => {
        setDialog(!hideDialog);
        dialogClick('na', 'Manager Photo Uploaded', '', null);
        setReload(!reload);
      })
      .catch(() => {
        dialogClick('na', 'Manager Add', 'An error has occured during Insert!', null);
      });
  }
  const clickHandler = (args) => {
    if (grid && grid.current && args.item.properties.text === 'Invite') {
      const selectedRecords = grid.current.getSelectedRecords();
      const recipient = prompt('Please enter the email address of the Manager that you would like to receive the invitation!', selectedRecords[0].email);
      if (recipient) {
        fetch(`${REACT_APP_API_ENDPOINT}/invite?associateid=${selectedRecords[0]._id}&manager=true&recipient=${recipient}&email=${usr.email}`, {
          method: 'GET',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
          },
        })
          .then((response) => response.json())
          .then((responseJson) => {
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              args.cancel = true;
              dialogClick('na', 'MAnager Invite', responseJson.response, null);
            }
          })
          .catch(() => {
            dialogClick('na', 'Manager Invite', 'An error has occured during Invitation request!', null);
            args.cancel = true;
          });
      }
    } else if (grid && grid.current && args.item.properties.text === 'PDF Export') {
      const properties = {
        fileName: `PDFExport_Manager_${new Date().toISOString()}.pdf`,
        pageOrientation: 'Landscape',
      };
      grid.current.pdfExport(properties);
    } else if (grid && grid.current && args.item.properties.text === 'Excel Export') {
      /*
            const properties = {
              fileName: `ExcelExport_Manager_${new Date().toISOString()}.xlsx`,
            };
            grid.current.excelExport(properties);
      */
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/excel?${query}&managers=true`;
      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      }).then((response) => response.json())
        .then((responseJson) => {
          // The added/edited data will be saved in the Grid
          dialogClick('na', 'Managers Excel handler', responseJson.response, null);
        });
    } else if (grid && grid.current && args.item.properties.text === 'Edit') {
      if (isMobile) {
        const selectedRow = grid.current.getSelectedRecords()[0];
        grid.current.startEdit(selectedRow);
      } else {
        setDialog(!hideDialog);
      }
    } else if (grid && grid.current && args.item.properties.text === 'Delete') {
      const selectedRow = grid.current.getSelectedRecords()[0];
      args.cancel = true;
      grid.current.deleteRecord(selectedRow);
    } else if (grid.current && args.item.properties.text === 'Add') {
      setFirstName('');
      setLastName('');
      setMobile('');
      setEmail('');
      setAddress('');
      setAddress1('');
      setCity('');
      setState('');
      setZip('');
      setSMSOptin(false);
      setEmailOptin(false);
      setEmployeeImage('https://monaco.zackat.com/blank.png');
      setOrganization(null);
      setManager(null);
      setManagerId('add_manager');
      setDialog(!hideDialog);
    }
  };
  function removePhoto(e) {
    let removeData = null;
    for (let idx = 0; idx < data.managers.length; idx += 1) {
      if (data.managers[idx]._id === e.target.id) {
        removeData = data.managers[idx];
        break;
      }
    }
    if (removeData == null || confirm(`Remove photo for ${removeData.first} ${removeData.last}?`) === false) {
      return;
    }
    if (removeData !== null) {
      fetch(`${REACT_APP_API_ENDPOINT}/mfileup`, {
        method: 'DELETE',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(removeData),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson && responseJson.response && responseJson.response !== 'OK') {
            dialogClick('na', 'Manager Delete', responseJson.response, null);
          }
          setReload(!reload);
        })
        .catch(() => {
          dialogClick('na', 'Manager Delete', 'An error has occured', null);
        });
    }
  }
  const customerGridImage = (props) => (
    <div className="image flex gap-4">
      {!props.image
        ? <input type="file" name="userfile" id={props._id} onChange={handleChange} />
        : (
          <div>
            <img
              className="rounded-full w-10 h-10"
              src={props.image && props.image.length > 0 ? props.image : profile}
              alt="employee"
            />
            <font color="black"><input type="submit" name="remove" id={props._id} value="&#x007F;" onClick={removePhoto} /></font>
          </div>
        )}
    </div>
  );
  const cancelProfile = () => {
    setManagerId('');
    setOrganization('');
  };

  const removeAssociate = () => {
    usr.limit = 1;
    if (selAnAssociate && selAnAssociate.length > 0) {
      usr.associate = selAnAssociate;
    } else {
      usr.associate = document.getElementById('associatename').value;
    }
    if (usr.associate.length === 0) {
      dialogClick('na', 'Remove Associate', 'Please supply an associate name to remove', null);
      return;
    }
    const url = `${REACT_APP_API_ENDPOINT}/managers?abbrev=true&action=remove&associate=${usr.associate}&managerid=${managerid}`;
    fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(usr),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        // The default edit operation is cancelled
        dialogClick('na', 'Manager Remove Associate', responseJson.response, null);
        if (responseJson.response.includes('OK')) {
          document.getElementById('associatename').value = '';
          document.getElementById('associates').value = document.getElementById('associates').value.replace(`${usr.associate},`, '');
          setAnAssociate('');
        }
        setReload(!reload);
      })
      .catch(() => {
        dialogClick('na', 'Manager Remove Associate', 'An error has occured!', null);
      });
  };
  const removeThisAssociate = () => {
    usr.limit = 1;
    if (usr.associate.length === 0) {
      dialogClick('na', 'Remove Associate', 'Please supply an associate name to remove', null);
      return;
    }
    const url = `${REACT_APP_API_ENDPOINT}/managers?abbrev=true&action=remove&associate=${usr.associate}&managerid=${managerid}`;
    fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(usr),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        // The default edit operation is cancelled
        dialogClick('na', 'Manager Remove Associate', responseJson.response, null);
        if (responseJson.response.includes('OK')) {
          document.getElementById('associatename').value = '';
          document.getElementById('associates').value = document.getElementById('associates').value.replace(`${usr.associate},`, '');
          setAnAssociate('');
        }
        setReload(!reload);
      })
      .catch(() => {
        dialogClick('na', 'Manager Remove Associate', 'An error has occured!', null);
      });
  };
  function unmanageAssociate(e) {
    setInitialValues(e.value);
    const updatedAssociates = [];
    if (e.value.length > 0) {
      e.value.forEach((aid) => {
        // Use All Associates
        // const result = manager.managedAssociates.find((a) => a.associateId === aid);
        const result = selAllAssociates.find((a) => a.associateId === aid);
        if (result) {
          updatedAssociates.push(result);
        }
      });
    }
    manager.managedAssociates = updatedAssociates;
  }

  const lookupAssociate = () => {
    usr.limit = 1;
    if (selAnAssociate && selAnAssociate.length > 0) {
      usr.associate = selAnAssociate;
    } else {
      usr.associate = document.getElementById('associatename').value;
    }
    if (usr.associate.length === 0) {
      dialogClick('na', 'Associate lookup', 'Please supply an associate name to lookup', null);
      return;
    }
    const url = `${REACT_APP_API_ENDPOINT}/managers?abbrev=true&action=add&associate=${usr.associate}&managerid=${managerid}`;
    fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(manager),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        // The default edit operation is cancelled
        dialogClick('na', 'Manager Lookup/Add Associate', responseJson.response, null);
        if (responseJson.response.includes('OK')) {
          document.getElementById('associatename').value = '';
          document.getElementById('associates').value += `${usr.associate},`;
          setAnAssociate('');
        }
        setReload(!reload);
      })
      .catch((error) => {
        dialogClick('na', 'Manager Lookup/Add Associate', `An error has occured during Associate Find! ${error}`, null);
      });
  };
  const saveProfile = () => {
    const result = orgData.find(({ id }) => id === selOrganization);
    if (!result) {
      DialogUtility.alert('Could not locate Organization!');
      return;
    }
    if (manager.organizationid !== selOrganization) {
      if (!confirm(`Would you like to move this Manager ${manager.name} from ${manager.organization} to ${result.value}`)) {
        return;
      }
    }
    if (result) {
      manager.organizationid = selOrganization;
      manager.organization = result.value;
    }
    if (selFirstName.length === 0) {
      dialogClick('na', 'Save Profile', 'Please provide a first name for the Manager', null);
      return;
    }
    if (selEmail.length > 0 && (!selEmail.includes('@') || !selEmail.includes('.'))) {
      dialogClick('na', 'Save Profile', 'Please provide a valid email address for the Manager', null);
      return;
    }
    manager.first = selFirstName;
    manager.last = selLastName;
    if (selMobile.length > 0) {
      manager.mobile = selMobile.replace(/\D/g, '');
      if (manager.mobile.length >= 10) {
        manager.mobile = manager.mobile.substring(manager.mobile.length - 10);
      }
    }
    manager.email = selEmail;
    manager.address = selAddress;
    manager.address1 = selAddress1;
    manager.city = selCity;
    manager.state = selState;
    manager.zip = selZip;
    manager.refresh = selRefresh;
    fetch(`${REACT_APP_API_ENDPOINT}/managers`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(manager),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        // The default edit operation is cancelled
        dialogClick('na', 'Manager Profile update', responseJson.response, null);
        setDialog(!hideDialog);
        setReload(!reload);
      })
      .catch((error) => {
        dialogClick('na', 'Manager Profile update', 'An error has occured!', null);
      });
  };
  const addProfile = () => {
    if (!selOrganization || selOrganization.length === 0) {
      dialogClick('na', 'Manager Organization', 'Required, please select an Organization for the Manager!', null);
      return;
    }

    const result = orgData.find(({ id }) => id === selOrganization);
    const newmanager = {};
    newmanager.organizationid = selOrganization;
    newmanager.organization = result.value;
    if (!selFirstName || selFirstName.length === 0) {
      dialogClick('na', 'Manager First Name', 'Required, please enter a First name for the Manager!', null);
      return;
    }
    if (!selLastName || selLastName.length === 0) {
      dialogClick('na', 'Manager Last Name', 'Required, please enter a Last name for the Manager!', null);
      return;
    }
    newmanager.first = selFirstName;
    newmanager.last = selLastName;
    if (selMobile.length > 0) {
      newmanager.mobile = selMobile.replace(/\D/g, '');
      if (newmanager.mobile.length >= 10) {
        newmanager.mobile = newmanager.mobile.substring(newmanager.mobile.length - 10);
      }
    }
    newmanager.email = selEmail;
    newmanager.address = selAddress;
    newmanager.address1 = selAddress1;
    newmanager.city = selCity;
    newmanager.state = selState;
    newmanager.zip = selZip;
    newmanager.refresh = selRefresh;

    fetch(`${REACT_APP_API_ENDPOINT}/managers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(newmanager),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        if (responseJson && responseJson._id) {
          newmanager._id = responseJson._id;
          setManagerId(newmanager._id);
        }
        setDialog(!hideDialog);
        if (!responseJson || !responseJson._id || responseJson._id.length === 0) {
          DialogUtility.alert('Manager add failed');
        }
        setReload(!reload);
        setReloadCounts(reloadCounts + 1);
      })
      .catch((error) => {
        dialogClick('na', 'Add Manager', 'An error has occured during New Associate Insert!', null);
      });
  };
  useEffect(() => {
    if (dialogRef && dialogRef.current && associateContent.length > 0) {
      dialogRef.current.show(); // Show dialog if no row is selected
      if (associateContent.includes('OK'));
      setReload(!reload);
      setAssociateContent('');
    }
  }, [associateContent]);

  useEffect(() => {
    if (grid && grid.current) {
      setInvite(false);
      const selectedRecords = grid.current.getSelectedRecords();
      if (selectedRecords && selectedRecords.length === 1) {
        if (selectedRecords.length > 0) {
          setEnableEditing(true);
          setManagerId(selectedRecords[0]._id);
        } else {
          setEnableEditing(false);
          setManagerId('');
          setInvite(true);
        }
      } else {
        setEnableEditing(false);
        setManagerId('');
        setInvite(true);
      }
    }
  }, [dataChanged]);

  function rowClicked(args) {
    if (args) {
      setManagerRow(args.rowIndex + 1);
      setManagerOrganization(args.rowData.organizationid);
    }
    setDataChanged(!dataChanged);
  }
  const header = () => (
    <div><h1>{managerid === 'add_manager' ? 'Add' : 'Edit'} Manager {manager && manager.first ? manager.first : ''} {manager && manager.last ? manager.last : ''} </h1></div>
  );
  const handleDialogClick = () => {
    setDialog(!hideDialog);
    if (grid && grid.current) {
      const selectedRow = grid.current.getSelectedRecords()[0];
      if (selectedRow && selectedRow._id) {
        setManagerId(selectedRow._id);
        setManager(selectedRow);
      }
    }
  };
  const savebuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        saveProfile();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'SAVE',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'CANCEL',
      },
    },
  ];
  const addbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        addProfile();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'ADD',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'CANCEL',
      },
    },
  ];
  const organizations = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.organization,
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };
  const profileTemplate = () => (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalhalh">
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
        {managerid !== 'add_manager' && (
        <div className="e-input-group">
          <div className="mt-20" style={{ width: '100vw', backgroundColor: '#F6821E20' }}>
            <MultiSelectComponent
              floatLabelType="Auto"
              placeholder="Managed Associates"
              id="managedassociates"
              dataSource={selAllAssociates}
              mode="CheckBox"
              fields={{ value: 'associateId', text: 'associateName', selected: true }}
              value={initialValues}
              readOnly
              onChange={(e) => { unmanageAssociate(e); }}
            >
              <Inject services={[CheckBoxSelection]} />
            </MultiSelectComponent>
          </div>
          {/*
          <TextBoxComponent
            placeholder="Associates"
            title="Controlled via Associate tab"
            value={selAssociates || 'unassigned'}
            id="associates"
            readOnly
            cssClass="e-outline"
            floatLabelType="Auto"
            onChange={(v) => { setAssociates(v.value); }}
          />
          */}
        </div>
        )}
        {managerid !== 'add_manager' && 1 === 2 && (
          <div className="e-input-group">
            <TextBoxComponent placeholder="Enter Associates Name" value={selAnAssociate} id="associatename" required showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAnAssociate(v.value); }} />
            <ButtonComponent cssClass="e-info" onClick={lookupAssociate}>Add</ButtonComponent>
            <ButtonComponent cssClass="e-danger" onClick={removeAssociate}>Remove</ButtonComponent>
          </div>
        )}
      </div>
      <form>
        {managerid !== 'add_manager' && (
          <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
            <div className="e-input-group">
              <img src={selEmployeeImage} className="w-10 h-10" value={selFirstName} id={managerid} />
              <input type="file" name="userfile" id={managerid} onChange={handleChange} />
            </div>
          </div>
        )}
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-10">
          <div className="e-input-group">
            <TextBoxComponent
              placeholder="First"
              value={selFirstName}
              showClearButton
              cssClass="e-outline"
              floatLabelType="Auto"
              onChange={(v) => { setFirstName(v.value); }}
            />
            <TextBoxComponent
              placeholder="Last"
              value={selLastName}
              showClearButton
              cssClass="e-outline"
              floatLabelType="Auto"
              onChange={(v) => { setLastName(v.value); }}
            />
          </div>
        </div>
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
          <div className="e-input-group">
            <TextBoxComponent
              placeholder="Address"
              value={selAddress}
              showClearButton
              cssClass="e-outline"
              floatLabelType="Auto"
              onChange={(v) => { setAddress(v.value); }}
            />
          </div>
        </div>
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
          <div className="e-input-group">
            <TextBoxComponent
              placeholder="Address1"
              value={selAddress1}
              showClearButton
              cssClass="e-outline"
              floatLabelType="Auto"
              onChange={(v) => { setAddress1(v.value); }}
            />
          </div>
        </div>
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
          <div className="e-input-group">
            <TextBoxComponent
              placeholder="City"
              value={selCity}
              showClearButton
              cssClass="e-outline"
              floatLabelType="Auto"
              onChange={(v) => { setCity(v.value); }}
            />
            <TextBoxComponent
              placeholder="State"
              value={selState}
              showClearButton
              cssClass="e-outline"
              floatLabelType="Auto"
              onChange={(v) => { setState(v.value); }}
            />
            <TextBoxComponent
              placeholder="Zip"
              value={selZip}
              showClearButton
              cssClass="e-outline"
              floatLabelType="Auto"
              onChange={(v) => { setZip(v.value); }}
            />
          </div>
        </div>
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
          <div className="e-input-group">
            <TextBoxComponent
              placeholder="Email"
              value={selEmail}
              showClearButton
              cssClass="e-outline"
              floatLabelType="Auto"
              onChange={(v) => { setEmail(v.value); }}
            />
            <TextBoxComponent
              placeholder="Mobile"
              value={selMobile}
              showClearButton
              cssClass="e-outline"
              floatLabelType="Auto"
              onChange={(v) => { setMobile(v.value); }}
            />
            <TextBoxComponent
              placeholder="Refresh Rate"
              floatLabelType="Auto"
              title="Refresh Rate"
              showClearButton
              value={selRefresh}
              type="text"
              cssClass="e-outline"
              onChange={(v) => { setRefresh(v.value); }}
            />
          </div>
        </div>
        <div className="row custom-margin">
          <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6">
            <div className="e-input-group">
              <DropDownListComponent id="ddlelement" cssClass="e-outline" dataSource={organizations.params.dataSource} fields={organizations.params.fields} placeholder="Select Organization" floatLabelType="Auto" value={selOrganization} onChange={(v) => { setOrganization(v.value); }} />
            </div>
          </div>
        </div>
      </form>
    </div>
  );

  if (loading) {
    return <p>Loading... </p>;
  }
  if (data.organization && data.organization.length > 0) {
    data.organization.forEach((org) => {
      orgData.push({ id: org._id, value: org.title });
    });
  }
  const actionComplete = (args) => {
    const editedData = args.data;
    const cols = grid.current.columns;
    for (const col of cols) {
      if (col.headerText === 'Associates' || col.headerText === 'Image') {
        col.visible = true;
      }
    }
    if (assocRef && assocRef.value) {
      editedData.associates = assocRef.value;
    }

    /** Set initial Focus */
    if (args.requestType === 'beginEdit') {
      args.form.elements.namedItem('first').focus();
      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      if (dialog) {
        dialog.header = `Details of ${args.rowData.first} ${args.rowData.last}`;
      }
    } else if (args.requestType !== 'save' && args.form && args.requestType === 'add') {
      args.form.elements.namedItem('first').focus();
    } else if (args.requestType === 'delete') {
      let entry = ' this entry?';
      if (args.data.length > 1) {
        entry = ' these entries?';
      }
      if (args.data) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/managers`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              args.cancel = true;
              dialogClick('na', 'Manager Delete', responseJson.response, null);
            }
            setReload(!reload);
            setReloadCounts(reloadCounts - 1);
          })
          .catch((error) => {
            args.cancel = true;
          });
      }
    }
  };
  function setUserPreferences(pref, val) {
    if (!data.user.preferences) {
      data.user.preferences = {};
    }
    if (!data.user.preferences.managers) {
      data.user.preferences.managers = {};
    }
    if (pref === 'group') {
      data.user.preferences.managers = { group: val, sort: data.user.preferences.managers.sort };
    } else if (pref === 'sort') {
      data.user.preferences.managers = { group: data.user.preferences.managers.group, sort: val };
    }
    // Remove the New Password to avoid creating a new password
    data.user.newPassword = '';
    // Avoid Password comparison
    data.user.password = '';
    if (data.user.lastLogin && data.user.lastLogin === '') {
      data.user.lastLogin = '1970-01-01T00:00:00.000Z';
    }

    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(data.user),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          dialogClick('na', `Manager Preferences error ${pref}`, responseJson.response, null);
        }
        setReload(!reload);
      })
      .catch(() => {
        dialogClick('na', 'Manager Preferences', `Error ${pref}`, null);
      });
  }
  const actionBegin = (args) => {
    if (args.requestType === 'ungrouping' || args.requestType === 'grouping') {
      const index = groups.indexOf(args.columnName);
      if (index > -1 && args.requestType === 'ungrouping') { // only splice array when item is found
        groups.splice(index, 1); // 2nd parameter means remove one item only
      } else if (index === -1 && args.requestType === 'grouping') { // only splice array when item is found
        groups.push(args.columnName); // 2nd parameter means remove one item only
      }
      setUserPreferences('group', groups);
    } else if (args.requestType === 'sorting') {
      setUserPreferences('sort', [{ field: args.columnName, direction: args.direction }]);
    }

    if (grid && grid.current.columns) {
      const cols = grid.current.columns;
      for (const col of cols) {
        if (args.requestType === 'add') {
          if (col.headerText === 'Associates' || col.headerText === 'ID' || col.headerText === 'Image') {
            col.visible = false;
          }
        }
      }
    }
  };
  if (!data.role.associates.permissions.includes('Managers')) {
    return <p>Not authorized...</p>;
  }

  const editing = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    mode: 'Normal',
  };
  const onFileUpload = (args) => {
    // add addition data as key-value pair.
    const result = orgData.find(({ id }) => id === selUploadOrganization);
    if (!result || !result.value || result.value === '') {
      args.cancel = true;
      dialogClick('na', 'Manager File Import', 'Invalid Organization', null);
      return;
    }
    if (!confirm(`Upload to ${result.value}`)) {
      args.cancel = true;
      return;
    }
    args.customFormData = [{ organizationid: selUploadOrganization }];
  };
  function completeUpload(args) {
    //    dialogClick('na', 'Upload success', 'Your upload is complete!', null);
    DialogUtility.alert(`Upload Completed ${args.fileData[0].status}`);
    setReload(!reload);
  }
  let uploadObj;
  const path = {
    removeUrl: `${REACT_APP_API_ENDPOINT}/managersremove`,
    saveUrl: `${REACT_APP_API_ENDPOINT}/managersupload`,
  };
  const buttons = { browse: 'Choose File', clear: 'Clear All', upload: 'Upload All' };

  const FilterOptions = {
    type: 'Menu',
  };
  //          to="https://scribehow.com/viewer/Create_Update_View_or_Remove_Managers__S1lF5nTyQTqb3ASqBrDODQ"

  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh">
      <div className="flex">
        <Link
          className="my-link"
          to="/pdf/managers.pdf"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="Supervisory" title="Managers" />
      </div>
      <div id="droparea">
        {crudImport && !isMobile && (
          <div className="control-section accordion-control-section" style={{ width: '45%' }}>
            <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
              <AccordionComponent>
                <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                  <div className="e-input-group">
                    <div className="mt-4"> Import </div>
                  </div>
                  <div className="mt-2 e-input-group">
                    <div>
                      <DropDownListComponent id="ddlelement" cssClass="e-outline" dataSource={organizations.params.dataSource} fields={organizations.params.fields} placeholder="Select Organization" value={selUploadOrganization} onChange={(v) => { setUploadOrganization(v.value); }} />
                    </div>

                    <UploaderComponent
                      id="fileupload"
                      type="file"
                      ref={(uplaod) => { uploadObj = uplaod; }}
                      asyncSettings={path}
                      buttons={buttons}
                      multiple={false}
                      actionComplete={completeUpload}
                      autoUpload={false}
                      uploading={onFileUpload}
                      allowedExtensions=".csv"
                    />
                  </div>
                </div>
              </AccordionComponent>
            </div>
          </div>
        )}
      </div>
      {!loading && (
        <div>
          <ToolbarComponent id="toolbar">
            <ItemsDirective>
              <ItemDirective text="Search" template={searchComponent} disabled={false} style={{ float: 'right !important' }} />
              <ItemDirective type="Separator" />
            </ItemsDirective>
          </ToolbarComponent>
        </div>
      )}
      {!hideDialog && (
        <DialogComponent
          header={header}
          content={profileTemplate}
          buttons={managerid !== 'add_manager' ? savebuttons : addbuttons}
          width="55%"
          height="85%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setManagerId(''); setDialog(!hideDialog); }}
          close={() => { setDialog(!hideDialog); }}
        />
      )}

      <div className="flex" height="300px">
        <div className="e-adaptive-demo e-bigger">
          <div className="e-mobile-layout">
            <div className="e-mobile-content">
              <GridComponent
                dataSource={data.managers}
                id="gridmanagers"
                enableHover={false}
                toolbar={toolbarOptions}
                editSettings={editing}
                dataBound={dataBound}
                allowSorting
                width="auto"
                allowResizing
          // allowFiltering={data && data.managers && data.managers.length > 0}
          // filterSettings={FilterOptions}
                actionComplete={actionComplete}
                actionBegin={actionBegin}
                allowGrouping
                allowPdfExport
                allowExcelExport
                groupSettings={groupOptions}
                sortSettings={sortOptions}
                allowTextWrap
                recordClick={rowClicked}
                toolbarClick={clickHandler}
                ref={grid}
                enableAdaptiveUI
                enableStickyHeader={!isMobile}
                rowRenderingMode={zRenderMode}
                enableAltRow
                enablePersistence
              >
                <ColumnsDirective>
                  {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                  <ColumnDirective
                    field="_id"
                    headerText="ID"
                    width="100"
                    format="C2"
                    visible={false}
                    textAlign="Left"
                    isPrimaryKey
                  />
                  <ColumnDirective
                    field="first"
                    headerText="First"
                    width="120"
                    textAlign="Left"
                    validationRules={valuerules}
                  />
                  <ColumnDirective
                    field="last"
                    headerText="Last"
                    width="120"
                    textAlign="Left"
                    validationRules={valuerulesnot}
                  />
                  <ColumnDirective
                    field="email"
                    headerText="Email"
                    width="120"
                    textAlign="Left"
                    validationRules={valueruleemail}
                  />
                  <ColumnDirective
                    field="organizationid"
                    headerText="Organization"
                    width="100"
                    textAlign="Left"
                    editType="dropdownedit"
                    validationRules={valuerules}
                    visible
                    foreignKeyField="_id"
                    foreignKeyValue="title"
                    dataSource={organizations.params.dataSource}
                  />
                </ColumnsDirective>
                <Inject services={[Selection, Toolbar, Edit, Sort, Search, Resize, ForeignKey, LazyLoadGroup, Group, PdfExport, ExcelExport]} />
                {/* Filter */}
              </GridComponent>
            </div>
            <ToolbarComponent id="toolbar2">
              <ItemsDirective>
                <ItemDirective template={pageComponent} float="left" />
                <ItemDirective type="Separator" />
              </ItemsDirective>
            </ToolbarComponent>
          </div>
        </div>
      </div>
      <DialogComponent ref={dialogRef} header="Associate Action" content={associateContent} showCloseIcon width="300px" buttons={dialogButtons} visible={false} />
    </div>
  );
};

export default ManagerControlCenter;
